import type { ReactNode } from "react";

import type { IDropdownButtonProps } from "@similarweb/ui-components";

import FilterDropdownButton from "app/pages/sales-intelligence/common-components/dropdown/FilterDropdownButton/FilterDropdownButton";
import type { Translatable } from "app/pages/sales-intelligence/types";

type Props = Pick<IDropdownButtonProps, "isOpen" | "disabled" | "hasValue"> & {
    id: string;
    children: ReactNode;
    placeholder?: Readonly<Translatable>;
};

const JobPositionDropdownButton = (props: Props) => {
    const { children, id, isOpen: isActive, disabled, hasValue, placeholder } = props;

    return (
        <FilterDropdownButton
            isActive={isActive}
            isDisabled={disabled}
            hasValue={hasValue}
            placeholder={placeholder ?? { key: `si.onboarding.job-position-dropdown.placeholder` }}
            dataAutomation={`filter-button-${id}`}
        >
            {children}
        </FilterDropdownButton>
    );
};

export default JobPositionDropdownButton;
